module.exports = __webpack_public_path__ + "static/media/timeline-small.f77fd91f.mp4";